export default "__VITE_ASSET__Bn6c__AW__"